// extracted by mini-css-extract-plugin
export default {"container":"DaysDifference_container__n69zS","yellow":"DaysDifference_yellow__lLyfm","red":"DaysDifference_red__l7Rfz","orange":"DaysDifference_orange__4Aa3d"};